import React from 'react';
import { useLanguage } from '../../store/language-context';
import logo from '../../assets/used-icons/speaker.png'; // Replace with actual logo path
const SpeakerCard = ({ name, title, company }) => {
    const { language } = useLanguage();
    
    return (
        <div className="bg-white rounded-lg p-6 shadow-md mx-2 relative">
            {/* Diamond Logo */}
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-20 h-20 bg-white shadow-md transform rotate-45 flex items-center justify-center z-10"
            style={{border:'2px solid #6a2f38'}}>
                <img 
                    src={logo} 
                    alt={`${company} logo`}
                    className="w-10 h-10 transform -rotate-45"
                />
            </div>
            
            {/* Speaker Info */}
            <div className="mt-12 text-center">
                <h3 className={`text-xl font-bold text-gray-800 mb-2 ${language === 'ar' ? 'font-arabic' : ''}`}>
                    {name}
                </h3>
                <p className={`text-sm text-gray-600 ${language === 'ar' ? 'font-arabic' : ''}`}>
                    {title}
                </p>
                <p className={`text-sm text-gray-500 ${language === 'ar' ? 'font-arabic' : ''}`}>
                    {company}
                </p>
            </div>
        </div>
    );
};

export default SpeakerCard;
